<template>
  <div class="books">
    <div class="title row">
      <i></i>
      <span class="flex cc">{{title}}</span>
      <a v-if="showRefresh" class="ccc refresh" @click="showRefreshAction">换一批</a>
      <a v-if="showMore" class="cc more" @click="showMoreAction">更多</a>
    </div>
    <ul v-if="books && books.length > 0" class="booklist-w100">
      <li v-for="(item, index) in books" :key="index">
        <a class="cc" @click="toBookDetail(item.bookId)">
          <div class="pic">
            <img :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.horiCover" :zoom="2000" v-lazy="require('../../assets/images/loading_ho.jpg')">
            <span v-if="item.showPop" :class="['book-pop2', item.popClass]"></span>
            <span class="book-name">{{item.title}}</span>

            <p v-if="item.publishStatus === 'finish'" class="book-sum">
              <span>共<i class="c-g">{{item.chapterCount}}</i>话</span>
              <span class="tag-green">{{getPublishStatusText(item.publishStatus)}}</span>
            </p>
            <p v-if="item.publishStatus !== 'finish'" class="book-sum">
              <span>更新至第<i>{{item.chapterCount}}</i>话</span>
              <span class="tag-red">{{getPublishStatusText(item.publishStatus)}}</span>
            </p>
          </div>
          <p class="f12">{{item.abstractContent}}</p>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
  import {getImg} from "../../services/urlService";
  import {getImgPlaceholder} from "../../services/urlService";

  export default {
    name: "books-full",
    props: {
      title: String,
      books: Array,
      showTitle: {
        type: Boolean,
        default: true
      },
      showRefresh: {
        type: Boolean,
        default: false
      },
      showMore: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {}
    },
    methods: {
      toBookDetail(id) {
        this.$router.isBack = false;
        this.$router.push(`/book/${id}`)
      },
      showMoreAction() {
        this.$emit('show-more');
      },
      showRefreshAction(){
        this.$emit('show-refresh');
      },
      getPublishStatusText(code) {
        if (code === 'finish') {
          return '完结'
        } else {
          return '连载'
        }
      }
    },
    watch: {
      books(data) {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/share/books-full.vue